import * as yup from 'yup'
import {
  formatDateOrNull,
  ISO_DATE_MIDNIGHT_FORMAT,
  parseISODate,
  validateNullableBoolean,
  validateNullableString,
  validateRequiredString
} from '../../../../../utils'

const validateDateType = () =>
  yup
    .mixed()
    .test(
      'test-date-type',
      'common.commonErrors.invalidDate',
      function (value) {
        if (!value) return true
        return parseISODate(value) !== null
      }
    )

const validateDateTypeRequiredIfNewRow = () =>
  yup
    .mixed()
    .test(
      'test-date-type',
      'common.commonErrors.invalidDate',
      function (value) {
        if (!value) return true
        return parseISODate(value) !== null
      }
    )
    .test(
      'test-required-if-new-row',
      'common.commonErrors.required',
      function (value) {
        if (!value && this.parent?.isRowNew === true) return false
        return true
      }
    )

export const validationSchema = yup.object({
  tyosuhteet: yup.array().of(
    yup.object({
      taNimi: validateRequiredString(),
      tpNimi: validateNullableString(),
      alkupvm: validateDateTypeRequiredIfNewRow(),
      loppupvm: validateDateType().test(
        'test-start-before-end',
        'pages.ownInfoPage.employment.employments.endDate.error.endBeforeStart',
        function (value) {
          if (!value || !this.parent.alkupvm) return true
          const formatted = formatDateOrNull(
            this.parent.alkupvm,
            ISO_DATE_MIDNIGHT_FORMAT
          )
          if (!formatted) return true
          return formatted <= value
        }
      ),
      paatoiminen: validateNullableBoolean(),
      taPerintaText: yup
        .string()
        .test(
          'test-payment-type',
          'common.commonErrors.required',
          function (value) {
            if (!value && this.parent.isRowNew) {
              return false
            }
            return true
          }
        )
    })
  )
})
